/** Normalize an href to a trailing-slash-free pathname for tab route matching. */
export function getWorkspaceTabPathname(href: string): string {
  return (
    new URL(href, 'https://local.invalid').pathname.replace(/\/+$/, '') || '/'
  )
}
